import React, { useState, useEffect } from 'react';
import { StaffApplicantSearchContainerApplicantApplicantUserResultsFieldsFragment } from '../../../../generated';
import { PageHeader } from '@ant-design/pro-layout';
import { ApplicantSearchFilterContainer } from '../components/applicant-search-filter.container';
import { ApplicantSearchContainer } from '../components/applicant-search.container';
import FilterMenuToggle from '../../../shared/filter-menu-toggle';
import { SubPageLayout } from '../sub-page-layout';
import { Typography } from 'antd';

interface ApplicantSearchProps {}

export const ApplicantSearch: React.FC<ApplicantSearchProps> = () => {
  const [filterDataCount, setFilterDataCount] = React.useState<StaffApplicantSearchContainerApplicantApplicantUserResultsFieldsFragment>({});
  const [isMobile, setIsMobile] = useState(false);
  const [filterMenuOpen, setFilterMenuOpen] = useState(false);
  const [refreshQuery, setRefreshQuery] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <SubPageLayout header={<PageHeader title={<Typography.Title className="staff-title">Applicant Search</Typography.Title>} />}>
      {isMobile && <FilterMenuToggle isOpen={filterMenuOpen} onToggle={() => setFilterMenuOpen(!filterMenuOpen)} />}
      <div className={`flex flex-col text-left ${isMobile ? 'px-0' : 'px-5'}`}>
        <div className={`flex ${isMobile ? 'flex-col' : 'flex-row'} overflow-x-auto gap-5 whitespace-nowrap mt-5`}>
          {(filterMenuOpen || !isMobile) && <ApplicantSearchFilterContainer filterDataCount={filterDataCount} setRefreshQuery={setRefreshQuery} />}
          <ApplicantSearchContainer isMobile={isMobile} setFilterDataCount={setFilterDataCount} refreshQuery={refreshQuery} setRefreshQuery={setRefreshQuery} />
        </div>
      </div>
      {/* <DateInformationFooter /> */}
    </SubPageLayout>
  );
};
